import Account from "./Account";
import { withNavigation } from "../../Common/withNavigation";
import { connect } from "react-redux";
import {
  getallorderRequest,
  getwishlistRequest,
  addAddressRequest,
  getaddressRequest,
  insertprofileRequest,
  getprofileRequest,
} from "./Account-slice";
import {
  getCartRequest,
  insertCartRequest,
  removewishlistrequest,
} from "../Home/Home-slice";

const mapStateToProps = (state) => {
  return {
    allorderdata: state.Account.allorderdata?.data,
    getallorderloading: state.Account.getallorderloading,
    getallordererror: state.Account.getallordererror,
    wishlistdata: state.Account.wishlistdata?.data,
    addcartdata: state.Home.Cartdata,
    removewishlistdata: state.Home.removewishlistdata,
    addAddressData: state.Account.addAddressData,
    addAddressLoading: state.Account.addAddressLoading,
    addAddressError: state.Account.addAddressError,
    getaddressData: state.Account.getaddressData,
    getaddressLoading: state.Account.getaddressLoading,
    getaddressError: state.Account.getaddressError,
    getprofiledataData: state.Account.getprofiledataData?.data,
    insertprofiledata: state.Account.insertprofiledata?.message,
    insertprofileloading: state.Account.insertprofileloading,
    insertprofileerror: state.Account.insertprofileerror,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getallorderRequest: (payload) => dispatch(getallorderRequest(payload)),
    getwishlistRequest: () => dispatch(getwishlistRequest()),
    getCartRequest: () => dispatch(getCartRequest()),
    insertCartRequest: (data) => dispatch(insertCartRequest(data)),
    removewishlistrequest: (data) => dispatch(removewishlistrequest(data)),
    addAddressRequest: (data) => dispatch(addAddressRequest(data)),
    getaddressRequest: () => dispatch(getaddressRequest()),
    insertprofileRequest: (data) => dispatch(insertprofileRequest(data)),
    getprofileRequest: () => dispatch(getprofileRequest()),
  };
};

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps)(Account)
);
